import { keyframes } from '@emotion/react';
import { getFontSize } from '../../../../constants/fontSizes';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const contactFormStyles = (isInView) => {
  return {
    formContainer: {
      backgroundColor: 'secondary.main',
      padding: {xs: "20px", lg: '100px'},
      paddingRight: {xs: '20px', lg: '20%'},
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      gap: '25px',
      height: '100%',
      '& > *': {
        opacity: isInView ? 0 : 0,
        ...(isInView && {
          animation: `${fadeIn} 0.8s ease-out 1.5s forwards`,
        }),
      },
    },
  heading: {
    fontFamily: 'Lato',
    fontWeight: 400,
    fontSize: getFontSize(24),
    lineHeight: {xs: '20px', md: '28px', lg: '35px', xl: '38px'},
    letterSpacing: '-0.02em',
    color: 'primary.main',
  },
  subtitle: {
    fontFamily: 'Aurora',
    fontWeight: 700,
    fontSize: getFontSize(82),
    lineHeight: {xs: '50px', md: '70px', lg: '90px', xl: '100px'},
    letterSpacing: '-0.02em',
    color: 'primary.main',
  },
  inputRow: {
    display: 'flex',
    gap: '16px',
  },
  inputField: {
    flex: 1,
    '& .MuiOutlinedInput-root': {
      color: 'primary.main',
      borderRadius: '14px',
      gap: '10px',
      '& fieldset': {
        borderColor: '#EAEAEA',
        borderWidth: '2px',
      },
      '&:hover fieldset': {
        borderColor: '#EAEAEA',
        borderWidth: '2px',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#EAEAEA',
        borderWidth: '2px',
      },
      '& input': {
        paddingTop: '17px',
        paddingRight: '24px',
        paddingBottom: '17px',
        paddingLeft: '24px',
      },
      '& input::placeholder': {
        color: '#7b7b7b',
        opacity: 1,
      },
    },
    '& .MuiInputLabel-root': {
      color: '#7b7b7b',
      fontSize: getFontSize(18),
      paddingLeft: "5px",
      '&.Mui-focused': {
        color: '#7b7b7b',
      },
    },
  },
  phoneInputContainer: {
    width: '100%',
    position: 'relative',
    '& .PhoneInput': {
      width: '100%',
      display: 'flex',
      position: 'relative',
    },
    '& .PhoneInputCountry': {
      position: 'absolute',
      left: '14px',
      top: '50%',
      transform: 'translateY(-50%)',
      zIndex: 2,
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
      pointerEvents: 'none',
      '& .PhoneInputCountrySelect': {
        pointerEvents: 'all',
        border: 'none',
        background: 'transparent',
        padding: '4px 0',
        fontSize: '1rem',
        cursor: 'pointer',
        color: '#7b7b7b',
        '&:focus': {
          outline: 'none',
        },
      },
    },
    '& .PhoneInputCountryIcon': {
      boxShadow: '0 0 0 0.06em rgba(0,0,0,0.1)',
    },
    '& .PhoneInputCountrySelectArrow': {
      display: 'none',

    },
    '& .MuiOutlinedInput-root': {
      paddingLeft: '50px',
      color: '#1F1F1F',
      borderRadius: '14px',
      gap: '10px',
      '& fieldset': {
        borderColor: '#EAEAEA',
        borderWidth: {xs: '1px', md: '2px'},
      },
      '&:hover fieldset': {
        borderColor: '#EAEAEA',
        borderWidth: {xs: '1px', md: '2px'},
      },
      '&.Mui-focused fieldset': {
        borderColor: '#EAEAEA',
        borderWidth: {xs: '1px', md: '2px'},
      },
      '& input': {
        color: '#1F1F1F',
        paddingTop: '17px',
        paddingRight: '24px',
        paddingBottom: '17px',
        paddingLeft: '0px !important',
      },
      '&.Mui-focused input': {
        color: '#1F1F1F',
        paddingTop: '17px',
        paddingRight: '24px',
        paddingBottom: '17px',
        paddingLeft: '0px !important',
      },
    },
  },
  textarea: {
    '& .MuiOutlinedInput-root': {
      color: '#7b7b7b',
      borderRadius: '14px',
      gap: '10px',
      '& fieldset': {
        borderColor: '#EAEAEA',
        borderWidth: '2px',
      },
      '&:hover fieldset': {
        borderColor: '#EAEAEA',
        borderWidth: '2px',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#EAEAEA',
        borderWidth: '2px',
      },
      '& textarea': {
        paddingTop: '17px',
        paddingRight: '24px',
        paddingBottom: '17px',
        paddingLeft: '24px',
      },
      '& textarea::placeholder': {
        color: '#7b7b7b',
        opacity: 1,
      },
    },
    '& .MuiInputLabel-root': {
      color: '#7b7b7b',
      '&.Mui-focused': {
        color: '#7b7b7b',
      },
    },
  },
  sendButton: {
    width: {xs: '150px', lg: 'auto'},
    height: {xs: '50px', lg: '62px'},
    borderRadius: '52px',
    padding: {xs: '6px 8px', lg: '21px 44px'},
    backgroundColor: 'primary.main',
    color: 'secondary.main',
    textTransform: 'none',
    alignSelf: 'flex-start',
    '&:hover': {
      backgroundColor: 'primary.main',
      opacity: 0.9,
    },
  },
  buttonText: {
    fontSize: getFontSize(18),
    fontWeight: 600,
    color: 'secondary.main',
  },
  };
};

